module.exports = __webpack_public_path__ + "img/mozzarella-cheese-sticks.0e05ecba.jpg";